export const categoryPathMap = {
  // START: ESG
  ESG자료실: "esg-guide/",
  "ESG 환경뉴스": "esg-guide/news/",
  "ESG 뉴스레터": "esg-guide/letter/",
  "소재와 포장재": "esg-guide/blog/package/",
  "제작사례 & 포장재리뷰": "esg-guide/blog/make/",
  // END: ESG

  // START: CSBOARD
  공지사항: "csboard/notice",
  FAQ: "csboard/faq/",
  "자료 다운로드": "csboard/library/",
  "제휴 문의": "csboard/contact",
  "패키징 제안받기": "csboard/b2b/",
  구해드립니다: "csboard/service/",
  // 추가 카테고리...
};
